<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/currencyExchangeList" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.createCurrencyExchange") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.baseCurrency")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.baseCurrency')"
                >
                  <v-select
                    label="item"
                    v-model="baseCurrency"
                    :options="baseCurrencyList"
                    @input="selectedFirstItems(baseCurrency)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.status") }}
                  <span class="required">*</span>
                </small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.status')"
                >
                  <v-select
                    label="item"
                    v-model="status"
                    :options="statusList"
                    @input="selectedSecondItems(status)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.conversionCurrency")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.conversionCurrency')"
                >
                  <v-select
                    label="item"
                    v-model="currency"
                    :options="conversioncurrencyList"
                    @input="selectedThirdItems(currency)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.validFrom")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.validFrom')"
                >
                  <datepicker
                    v-model="validFrom"
                    :type="type"
                    onfocus="(this.type='date')"
                    :placeholder="getDateStr"
                    class="mb-2 font-semibold"
                    :disabled-dates="{ from: new Date() }"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.conversionRate')"
              >
                <vs-input
                  v-model="conversionRate"
                  :label="$t('system.label.conversionRate')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.validTo") }}
                  <span class="required">*</span>
                </small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.validTo')"
                >
                  <datepicker
                    v-model="validTo"
                    :placeholder="$t('placeholder.label.SelectDate')"
                    class="mb-2 font-semibold"
                    :disabled-dates="{
                      to: new Date(new Date().toDateString()),
                    }"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createCurrencyRate"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      type: "text",
      CtemplateData: {},
      baseCurrencyId: 0,
      baseCurrencyList: [],
      baseCurrency: "",
      currencyId: 0,
      conversioncurrencyList: [],
      currency: "",
      statusId: 0,
      statusList: [],
      status: "",
      validFrom: Date.now(),
      validTo: "",
      conversionRate: "",
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    getDateStr() {
      let s = moment(new Date()).format("DD/MM/YYYY");
      return s;
    },
    breadcrumbs() {
      return [
        {
          name: this.$t("reports.label.currencyMaster"),
          to: "/currencyExchangeList",
        },
        { name: this.$t("system.label.createCurrencyExchange"), to: "/" },
      ];
    },
  },
  methods: {
    async getTemplateData() {
      try {
        const response = await this.$store.dispatch(
          "currencyExchange/getCreateTemplateCountryCurrency"
        );
        this.CtemplateData = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async selectedFirstItems(off) {
      this.CtemplateData.currencydata.currencyOptions.map((e) => {
        if (e.code + " -- " + e.name == off) {
          this.baseCurrencyId = e.id;
        }
      });
    },
    async selectedSecondItems(off) {
      this.CtemplateData.statusData.map((e) => {
        if (e.value == off) {
          this.statusId = e.id;
        }
      });
    },
    async selectedThirdItems(off) {
      this.CtemplateData.currencydata.currencyOptions.map((e) => {
        if (e.code + " -- " + e.name == off) {
          this.currencyId = e.id;
        }
      });
    },
    async createCurrencyRate() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        let payload = {
          baseCurrency: this.baseCurrencyId,
          conversionRate: this.conversionRate,
          currency: this.currencyId,
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          status: this.status,
          validFrom: moment(this.validFrom).format("DD MMMM YYYY"),
          validTo: moment(this.validTo).format("DD MMMM YYYY"),
        };
        await this.$store.dispatch(
          "currencyExchange/createCountryCurrencyAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Currency Exchange Created Successfully!",
          type: "success",
        });
        this.$router.push("/currencyExchangeList");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.baseCurrency = null;
      this.currency = null;
      this.conversionRate = null;
      this.status = null;
      this.validTo = null;
    },
  },
  watch: {
    CtemplateData(val) {
      for (let role of val.currencydata.currencyOptions) {
        this.baseCurrencyList.push(role.code + " -- " + role.name);
      }
      for (let role of val.currencydata.currencyOptions) {
        this.conversioncurrencyList.push(role.code + " -- " + role.name);
      }
      for (let role of val.statusData) {
        this.statusList.push(role.value);
      }
    },
  },
  mounted() {
    this.getTemplateData();
  },
};
</script>
